import { render, staticRenderFns } from "./createMapping.vue?vue&type=template&id=82859b0a&scoped=true&"
import script from "./createMapping.vue?vue&type=script&lang=js&"
export * from "./createMapping.vue?vue&type=script&lang=js&"
import style0 from "./createMapping.vue?vue&type=style&index=0&id=82859b0a&scoped=true&lang=css&"
import style1 from "./createMapping.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82859b0a",
  null
  
)

export default component.exports